import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promotiondetails-form',
  templateUrl: './promotiondetails-form.component.html',
  styleUrls: ['./promotiondetails-form.component.css']
})
export class PromotiondetailsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/promotiondetails/promotiondetails-form/promotiondetails-form.component.ts